import React from 'react';
import { Box, Container, Grid, Typography, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';

const Footer = () => {
  const footerCategories = {
    NGF: [
      //{ label: 'About Us', href: '#' },
      //{ label: 'Teams', href: '#' },
     // { label: 'Schedule', href: '#' },
     // { label: 'News', href: '#' },
    ],
    'Social Media': [
      { label: 'Facebook', href: 'https://www.facebook.com/share/1ABwZqRizZ/' },
      { label: 'Instagram', href: 'https://www.instagram.com/gauntlet.federation/' },
      //{ label: 'Twitter', href: '#' },
      //{ label: 'YouTube', href: '#' },
    ],
    Help: [
      //{ label: 'FAQ', href: '#' },
      //{ label: 'Support', href: '#' },
      { label: 'Contact Us', href: 'ngfederation.com/contact' },
      //{ label: 'Tickets', href: '#' },
    ],
    Legal: [
      //{ label: 'Privacy Policy', href: '#' },
      //{ label: 'Terms of Service', href: '#' },
      //{ label: 'Cookie Policy', href: '#' },
      //{ label: 'Disclaimer', href: '#' },
    ],
  };

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#000',
        color: 'white',
        pt: 8,
        pb: 4,
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '6px',
          background: 'linear-gradient(90deg, #0D47A1 0%, #D32F2F 50%, #0D47A1 100%)',
        },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Logo Section */}
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: { xs: 'center', md: 'flex-start' },
            }}
          >
            <Box
              component={Link}
              to="/"
              sx={{
                textDecoration: 'none',
                mb: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: { xs: 'center', md: 'flex-start' },
              }}
            >
              <Box
                component="img"
                src="/2T.png"
                alt="NGF Logo"
                sx={{
                  width: 100,
                  height: 100,
                  objectFit: 'contain',
                  cursor: 'pointer',
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.05)',
                  },
                }}
              />
            </Box>
            <Typography
              variant="body2"
              sx={{
                color: 'rgba(255, 255, 255, 0.7)',
                textAlign: { xs: 'center', md: 'left' },
                maxWidth: 280,
                mb: 2,
              }}
            >
              National Gauntlet Federation - The future of competitive grappling
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: 'rgba(255, 255, 255, 0.5)',
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              © {new Date().getFullYear()} NGF. All rights reserved.
            </Typography>
          </Grid>

          {/* Menu Categories */}
          <Grid item xs={12} md={8}>
            <Grid container spacing={3}>
              {Object.entries(footerCategories).map(([category, links]) => (
                <Grid item xs={6} sm={3} key={category}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontFamily: '"Oswald", sans-serif',
                      fontWeight: 600,
                      mb: 2,
                      fontSize: '1.1rem',
                      letterSpacing: '0.05em',
                      color: category === 'NGF' ? 'primary.light' : 'secondary.light',
                      position: 'relative',
                      paddingBottom: '8px',
                      '&::after': {
                        content: '""',
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        width: '30px',
                        height: '2px',
                        backgroundColor:
                          category === 'NGF' ? 'primary.light' : 'secondary.light',
                      },
                    }}
                  >
                    {category}
                  </Typography>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    {links.map((link) => (
                      <MuiLink
                        key={link.label}
                        href={link.href}
                        underline="none"
                        sx={{
                          color: 'rgba(255, 255, 255, 0.7)',
                          fontSize: '0.9rem',
                          transition: 'all 0.3s ease',
                          position: 'relative',
                          width: 'fit-content',
                          '&:hover': {
                            color: 'white',
                            paddingLeft: '8px',
                          },
                          '&::before': {
                            content: '""',
                            position: 'absolute',
                            left: 0,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: '0',
                            height: '2px',
                            backgroundColor: 'secondary.main',
                            transition: 'width 0.3s ease',
                          },
                          '&:hover::before': {
                            width: '4px',
                          },
                        }}
                      >
                        {link.label}
                      </MuiLink>
                    ))}
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>

        {/* Bottom Bar */}
        <Box
          sx={{
            mt: 6,
            pt: 3,
            borderTop: '1px solid rgba(255, 255, 255, 0.1)',
            textAlign: 'center',
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: 'rgba(255, 255, 255, 0.5)',
              fontSize: '0.85rem',
            }}
          >
            Built with passion for the grappling community
          </Typography>
        </Box>
      </Container>

      {/* Decorative Background Elements */}
      <Box
        sx={{
          position: 'absolute',
          bottom: -100,
          right: -100,
          width: 300,
          height: 300,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(13, 71, 161, 0.1) 0%, transparent 70%)',
          pointerEvents: 'none',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: -150,
          left: -150,
          width: 400,
          height: 400,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(211, 47, 47, 0.1) 0%, transparent 70%)',
          pointerEvents: 'none',
        }}
      />
    </Box>
  );
};

export default Footer;